import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectDirection } from '@store/slices/uiSlice'

export const RtlProvider = ({ children }) => {
  const direction = useSelector(selectDirection)

  useEffect(() => {
    document.documentElement.dir = direction
    document.documentElement.lang = direction === 'rtl' ? 'ar' : 'en'
  }, [direction])

  return <>{children}</>
}
